<template>
  <div>
    <v-layout wrap>
      <v-flex xs12>
        <vue-element-loading
          :active="appLoading"
          :is-full-screen="true"
          background-color="#FFFFFF"
          color="blue"
          spinner="mini-spinner"
        />
        <ServerError v-if="ServerError" />
        <v-layout wrap>
          <v-flex xs12 pa-2>
            <span> <h2>Whale Shark Conservation Project</h2></span>
          </v-flex>
          <v-flex xs12 sm6 pa-2>
            <v-card elevation="2" to="/userlist">
              <v-layout wrap>
                <v-flex xs4>
                  <v-img height="150px" src="../../assets/images/login2.jpg">
                  </v-img>
                </v-flex>
                <v-flex xs8 text-center align-self-center>
                  <span class="subhead sbold" style="text-transform: uppercase"
                    >Total Number of Users: </span
                  >&nbsp;
                  <span
                    class="bold"
                    xs12
                    text-center
                    style="font-size: 40px; color: #313563"
                    >{{ usercount }}</span
                  >
                </v-flex>
              </v-layout>
            </v-card>
          </v-flex>
          <v-flex xs12 sm6 pa-2>
            <v-card elevation="2" to="/reports">
              <v-layout wrap>
                <v-flex xs4>
                  <v-img height="150px" src="../../assets/images/dash.jpg">
                  </v-img>
                </v-flex>
                <v-flex xs8 text-center align-self-center>
                  <span class="subhead sbold" style="text-transform: uppercase"
                    >Total Number of Records: </span
                  >&nbsp;
                  <span
                    class="bold"
                    xs12
                    text-center
                    style="font-size: 40px; color: #313563"
                    >{{ recordcount }}</span
                  >
                </v-flex>
              </v-layout>
            </v-card>
          </v-flex>
          <!-- <span>Total Number of Records:</span> <span>{{recordcount}}</span> -->
          <!-- <v-flex xs12 sm3 pa-2>
        
        <v-card elevation="2">
               <v-img  height="150px" src="../../assets/images/dash.jpg">

              </v-img>
              <v-layout wrap pa-3 pt-lg-2 pb-lg-2>
                 <v-flex xs12 text-center align-self-center>
                   <span  class="subhead bold" style="text-transform: uppercase">Total Number of Records</span> &nbsp; -->
          <!-- <span class="bold" style="color: green; font-size: 30px">{{recordcount}}</span> -->
          <!-- </v-flex>
                  <v-flex class=" bold" xs12 text-center style="font-size:45px;color:#313563">
                  {{recordcount}}
                 </v-flex>
              </v-layout>
          </v-card>
      </v-flex> -->
        </v-layout>
        <v-layout wrap>
          <v-flex xs12 class="sbold"
            ><span><h2>Recent Reports</h2></span></v-flex
          >
          <v-flex xs12 v-if="details" class="sbold">
            <v-simple-table>
              <template v-slot:default>
                <thead>
                  <tr>
                    <th class="text-left;" style="font-size: 15px">No.</th>
                    <th class="text-left;" style="font-size: 15px">Username</th>
                    <th class="text-left" style="font-size: 15px">Date</th>
                    <th class="text-left" style="font-size: 15px">Boat Name</th>
                    <th class="text-left" style="font-size: 15px">Boat No.</th>
                    <th class="text-left" style="font-size: 15px">Spot</th>
                    <th class="text-left" style="font-size: 15px">
                      Expected Length(ft)
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(value, i) in details" :key="i">
                    <!-- <td>{{ i + 1 }}</td> -->
                    <td>
                      <span>
                        {{ i + 1 }}
                      </span>
                    </td>
                    <td v-if="value.userid">
                      <router-link
                        style="text-decoration: none; color: black"
                        :to="'/uploaddetail?id=' + value._id"
                      >
                        {{ value.userid.first_name
                        }}{{ value.userid.last_name }}
                        </router-link>
                    </td>
                    <td v-if="value.create_date">
                       <router-link
                        style="text-decoration: none; color: black"
                        :to="'/uploaddetail?id=' + value._id"
                      >
                      {{ formatDate(value.create_date) }}
                       </router-link>
                    </td>

                    <td v-if="value.boatname">
                       <router-link
                        style="text-decoration: none; color: black"
                        :to="'/uploaddetail?id=' + value._id"
                      >
                      {{ value.boatname }}
                       </router-link></td>
                    <td v-if="value.boatno">
                       <router-link
                        style="text-decoration: none; color: black"
                        :to="'/uploaddetail?id=' + value._id"
                      >
                      {{ value.boatno }}
                       </router-link></td>
                    <td v-if="value.field">
                       <router-link
                        style="text-decoration: none; color: black"
                        :to="'/uploaddetail?id=' + value._id"
                      >
                      {{ value.field }}
                       </router-link></td>
                    <td v-if="value.length">
                       <router-link
                        style="text-decoration: none; color: black"
                        :to="'/uploaddetail?id=' + value._id"
                      >
                      {{ value.length }}
                       </router-link></td>
                  </tr>
                </tbody>
              </template>
            </v-simple-table>
          </v-flex>
        </v-layout>
        <v-layout wrap pt-2>
          <v-flex xs12 id="googlemap2"> </v-flex>
        </v-layout>
      </v-flex>
    </v-layout>
  </div>
</template>
<script
    src="https://maps.googleapis.com/maps/api/js?libraries=places&key=
AIzaSyB-wSOSvoBXfA5vn-23GR7OU5qTm8BFwlk&libraries=visualization,drawing">
</script>
<script>
import axios from "axios";
import store from "../../store";
export default {
  data() {
    return {
      ServerError: false,
      appLoading: false,
      userList: [],
      details: [],
      recordcount: 0,
      usercount: 0,
      gmap2: null,
      latt: null,
      lonn: null,
      icons: "",
      locations: null,
    };
  },

  computed: {
    userName() {
      return store.state.USDD;
    },
  },

  mounted() {
    this.getData();
    this.getMap();
  },

  methods: {
    addd() {
      store.commit("USD", "this is the second valur");
    },
    getData() {
      this.appLoading = true;
      axios({
        url: "/admin/home",
        method: "get",
        headers: {
          token: localStorage.getItem("token"),
        },
      })
        .then((response) => {
          this.appLoading = false;
          if (response.data.status) {
            this.recordcount = response.data.recordcount;
            this.usercount = response.data.usercount;
            this.details = response.data.data;

            this.locations = response.data.locations;
            for (let i = 0; i < this.locations.length; i++) {
              this.latt = this.locations[i].location[1];
              this.lonn = this.locations[i].location[0];
              this.marker = new google.maps.Marker({
                position: { lat: this.latt, lng: this.lonn },
                map: this.gmap2,
                icon: this.icons,
              });
              const infowindow = new google.maps.InfoWindow({
                content: String(
                  "<h3>" +
                    this.locations[i].boatname +
                    "</h3>" +
                    '<a href="/uploaddetail?id=' +
                    this.locations[i]._id +
                    '"><button class="RB " style="color:#d39c00;font-size:12px" >View Details</button></a>'
                ),
                maxWidth: 500,
              });
              this.marker.addListener("click", (eve) => {
                infowindow.open(this.map3, this.marker);
                infowindow.setPosition(eve.latLng);
              });
            }
          }
        })
        .catch((err) => {
          this.appLoading = false;
          this.ServerError = true;
          console.log(err);
        });
    },
    formatDate(item) {
      var dt = new Date(item);
      var day = dt.getDate();
      var year = dt.getFullYear();
      var hours = dt.getHours();
      var minutes = dt.getMinutes();
      dt = dt.toString();
      var ampm = hours >= 12 ? "pm" : "am";
      hours = hours % 12;
      hours = hours ? hours : 12;
      minutes = minutes < 10 ? "0" + minutes : minutes;
      var strTime =
        day +
        " " +
        dt.slice(4, 7) +
        " " +
        year +
        " , " +
        hours +
        ":" +
        minutes +
        " " +
        ampm;

      return strTime;
    },
    getMap() {
      this.gmap2 = new google.maps.Map(document.getElementById("googlemap2"), {
        center: { lat: 9.5260093, lng: 76.8144186 },
        zoom: 2,
      });
    },
  },
};
</script>
<style scoped>
#googlemap2 {
  height: 400px;
  width: 100%;
  margin: 0px;
  padding: 0px;
}
table.v-table thead th {
  font-size: 20px !important;
}
</style>